// extracted by mini-css-extract-plugin
export default {"formContainer":"component_formContainer__hZit6","loading":"component_loading__fXRAU","textArea":"component_textArea__H74hJ"};